import PlaceInLogo from "./../../assets/images/Logo-PlaceIn_BLANCO.png";
export default function Logo() {
  return (
    <img src={PlaceInLogo} alt="Logo PlaceIn" className="rounded scale-125" />
  );
}
